<template>
  <div class="buttons">
    <span
      v-for="(item, index) in getBtns"
      :key="index"
      class="btn"
      @click="handleChange(item.key)"
    >
      {{item.value}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'buttons',
  props: {
    data: Object
  },
  computed: {
    getBtns () {
      const arr = []
      try {
        this.data.value.map(v => {
          if (this.data.options[v]) {
            arr.push({ key: v, value: this.data.options[v] })
          }
        })
      } catch (e) {
        console.log('等待按钮组生成==>', e)
      }
      return arr
    }
  },
  methods: {
    handleChange (key) {
      this.$emit('change', key)
    }
  }
}
</script>

<style lang="scss" scoped>
  .buttons{
    display: flex;
    flex-direction: row;
    align-items: center;

    .btn{
      margin-right: 10px;
      cursor: pointer;
      color: #20a0ff;

      &:last-child{
        margin-right: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IMTable/components/tdBox/components/buttons/index.vue